export default __webpack_public_path__ + "static/media/avatar.019b41cb.jpg";